export const advertismentConstants = {
    GETADVERTISMETS_REQUEST: "GET_ADVERTISMETS_REQUEST",
    GETADVERTISMETS_SUCCESS: "GET_ADVERTISMETS_SUCCESS",
    GETADVERTISMETS_FAILURE: "GET_ADVERTISMETS_SUCCESS"
}